const ContinueButton = ({
  enabled,
  onClick = () => {},
  text = 'Continue',
  size = 'medium',
  extraClasses = null,
}: any) => {
  const buttonStyles = [
    'action-button',
    enabled ? 'enabled' : 'disabled',
    size,
    extraClasses,
  ].join(' ')

  return (
    <div className={['action-button-wrap', size].join(' ')}>
      <button
        type="submit"
        onClick={onClick}
        className={buttonStyles}
        disabled={!enabled}
        dangerouslySetInnerHTML={{ __html: text }}
      />
    </div>
  )
}

export default ContinueButton
